import { createFileRoute, redirect } from '@tanstack/react-router';

import { homeLanding } from '@/app/home-landing';
import { HomePage } from '@/features/home/home-page';
import { fetchOnboarding } from '@/lib/api/profiles';
import { fetchMyWork } from '@/lib/api/workforce';
import { getSession } from '@/lib/auth/session';

export const Route = createFileRoute('/_app/home')({
  beforeLoad: async () => {
    const { me, status } = getSession();
    if (status !== 'active') return; // offline or booting: the personal home, from the cache
    const target = await homeLanding(me, {
      hasWorkerRecord: async () => {
        const work = await fetchMyWork();
        return Boolean(work.profile) && work.engagements.length > 0;
      },
      onboarding: fetchOnboarding,
    });
    if (target) throw redirect({ ...target, replace: true } as never);
  },
  component: HomePage,
});
